import asCanvasElement from '../../utils/CanvasElement';
import BodyElement from './BodyElement';
import type { BodyElementProps } from './types';

export type { BodyElementProps };
export default asCanvasElement(BodyElement);
